// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customInputContainer_b1yW4 {
	position: relative;
}

.title_VXyJr {
	position: absolute;
	top: 4px;
	left: 8px;
	font-size: 12px;
	color: var(--_3c3a3a-color);
	-webkit-user-select: none;
	        user-select: none;
	pointer-events: none;
	margin-bottom: 4px;
}

.inputWrapper_B2mZo {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0px 8px;
	border-radius: 4px;
	cursor: pointer;
	background: var(--f5-background);
}

.customInput_lDphK {
	-webkit-user-select: none;
	        user-select: none;
	border: none;
	outline: none;
	background: transparent;
	cursor: pointer;
	width: 100%;
	font-size: 14px;
}

.arrow_Os3PU {
	width: 0;
	height: 0;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-top: 4px solid #666;
	margin-left: 8px;
	transition: transform 0.2s ease-in-out;
}

.dropdown_ITJ3g {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	max-height: 250px;
	overflow-y: auto;
	background-color: #ffffff;
	border-radius: 4px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	z-index: 1000;
}

.option_AtT9W {
	padding: 8px;
	cursor: pointer;
	color: var(--_3c3a3a-color);
	transition: background-color 0.15s;
	font-size: 13px;
	font-weight: 500;
}

.option_AtT9W:hover {
	background-color: var(--_16c0982e-background);
}

.selected_SGgrA {
	background-color: var(--_16c0982e-background);
}

.hovered_oOoj8 {
	background-color: var(--_16c0982e-background);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CustomDropDown.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,eAAe;CACf,2BAA2B;CAC3B,yBAAiB;SAAjB,iBAAiB;CACjB,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,yBAAiB;SAAjB,iBAAiB;CACjB,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,eAAe;CACf,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,QAAQ;CACR,SAAS;CACT,kCAAkC;CAClC,mCAAmC;CACnC,0BAA0B;CAC1B,gBAAgB;CAChB,sCAAsC;AACvC;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,iBAAiB;CACjB,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,wCAAwC;CACxC,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,2BAA2B;CAC3B,kCAAkC;CAClC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,6CAA6C;AAC9C","sourcesContent":[".customInputContainer {\n\tposition: relative;\n}\n\n.title {\n\tposition: absolute;\n\ttop: 4px;\n\tleft: 8px;\n\tfont-size: 12px;\n\tcolor: var(--_3c3a3a-color);\n\tuser-select: none;\n\tpointer-events: none;\n\tmargin-bottom: 4px;\n}\n\n.inputWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 0px 8px;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tbackground: var(--f5-background);\n}\n\n.customInput {\n\tuser-select: none;\n\tborder: none;\n\toutline: none;\n\tbackground: transparent;\n\tcursor: pointer;\n\twidth: 100%;\n\tfont-size: 14px;\n}\n\n.arrow {\n\twidth: 0;\n\theight: 0;\n\tborder-left: 4px solid transparent;\n\tborder-right: 4px solid transparent;\n\tborder-top: 4px solid #666;\n\tmargin-left: 8px;\n\ttransition: transform 0.2s ease-in-out;\n}\n\n.dropdown {\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\tright: 0;\n\tmax-height: 250px;\n\toverflow-y: auto;\n\tbackground-color: #ffffff;\n\tborder-radius: 4px;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tz-index: 1000;\n}\n\n.option {\n\tpadding: 8px;\n\tcursor: pointer;\n\tcolor: var(--_3c3a3a-color);\n\ttransition: background-color 0.15s;\n\tfont-size: 13px;\n\tfont-weight: 500;\n}\n\n.option:hover {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.selected {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.hovered {\n\tbackground-color: var(--_16c0982e-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customInputContainer": `customInputContainer_b1yW4`,
	"title": `title_VXyJr`,
	"inputWrapper": `inputWrapper_B2mZo`,
	"customInput": `customInput_lDphK`,
	"arrow": `arrow_Os3PU`,
	"dropdown": `dropdown_ITJ3g`,
	"option": `option_AtT9W`,
	"selected": `selected_SGgrA`,
	"hovered": `hovered_oOoj8`
};
export default ___CSS_LOADER_EXPORT___;
